import FmdBadRoundedIcon from '@mui/icons-material/FmdBadRounded';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import ShippingCancelIcon from '../../svg-icons/ShippingCancelIcon';
import ShippingDefaultIcon from '../../svg-icons/ShippingDefaultIcon';
import ShippingDoneIcon from '../../svg-icons/ShippingDoneIcon';
import ShippingInProgressIcon from '../../svg-icons/ShippingInProgressIcon';
import ErrorBoundary from '../errors/ErrorBoundary';
import InternalServerError from '../errors/InternalServerError.jsx';

const selectIconBasedOnShippingStatus = (status) => {
  switch (status) {
    case 'Créée':
      return null;
    case 'Erreur':
    case 'Refusée':
    case 'Annulée':
    case 'item_anomaly':
      return (
        <>
          <ShippingCancelIcon color={'error'} />
        </>
      );
    case 'Validée':
    case 'En attente SC':
    case 'En cours':
    case 'item_being_prepared':
      return (
        <>
          <ShippingDefaultIcon color={'info'} />
        </>
      );
    case 'Envoyé au STO':
    case 'En cours de traitement STO':
    case 'Traité par STO':
    case 'Prise en charge par TAV':
    case 'En cours de livraison':
    case 'item_being_delivered':
      return (
        <>
          <ShippingInProgressIcon color={'warning'} />
        </>
      );

    case 'Livrée':
    case 'item_delivery_succeed':
      return (
        <>
          <ShippingDoneIcon color={'success'} />
        </>
      );
    default:
      return <FmdBadRoundedIcon />;
  }
};

const ShippingStatusIcon = (props) => {
  const { orderStatus } = props;

  return (
    <ErrorBoundary
      fallback={<InternalServerError />}
      source="ShippingStatusIcon"
    >
      <Tooltip placement="top-start" title={`${orderStatus}`}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          {orderStatus ? selectIconBasedOnShippingStatus(orderStatus) : null}
        </Box>
      </Tooltip>
    </ErrorBoundary>
  );
};

export default ShippingStatusIcon;
